import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Toast } from "../components/SweatAlert";

export const _exportToExcel = ({ data, columns, fileName = "export.xlsx" }) => {
  if (!data || data.length === 0) {
    Toast.fire({ icon: "error", title: "⚠ No data to export" });
    return;
  }

  let exportData = data.map((row) => {
    if (columns && columns.length > 0) {
      let filtered = {};
      columns.forEach((col) => {
        filtered[col.title || col.dataIndex] = row[col.dataIndex];
      });
      return filtered;
    }
    return row;
  });

  const ws = XLSX.utils.json_to_sheet(exportData);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Changan Customers");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, fileName);
};